import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";

library.add(fas);

const v4ToV6Map = {
	dashboard: "gauge",
	navicon: "bars",
	remove: "xmark",
	close: "xmark",
	pencil: "pen",
	"trash-o": "trash-can",
	"drivers-license": "id-card",
	"drivers-license-o": "id-card",
	warning: "triangle-exclamation",
	"sign-out": "right-from-bracket",
};

const LegacyFontAwesome = ({
	name,
	className,
	size,
	spin,
	style,
	...props
}) => {
	useEffect(() => {
		if (process.env.NODE_ENV === "development") {
			console.warn(
				`[Deprecation Notice] Legacy FontAwesome component used with icon: "${name}". Please refactor to <FontAwesomeIcon icon={fa${name}} />.`,
			);
		}
	}, [name]);

	let iconName = name || "question-circle";
	let additionalClasses = "";

	if (iconName.includes(" ")) {
		const parts = iconName.split(" ");
		iconName = parts[0];
		additionalClasses = parts.slice(1).join(" ");
	}

	iconName = iconName.replace(/^fa-/, "");

	if (v4ToV6Map[iconName]) {
		iconName = v4ToV6Map[iconName];
	}

	const isSpinning =
		spin ||
		additionalClasses.includes("fa-spin") ||
		additionalClasses.includes("fa-pulse");

	return (
		<FontAwesomeIcon
			icon={["fas", iconName]}
			spin={!!isSpinning}
			className={`${className || ""} ${additionalClasses}`}
			style={style}
			size={size}
			{...props}
		/>
	);
};

export default LegacyFontAwesome;
